import { useEffect, useState } from "react";

/**
 * Only for multiEdit mode of Map
 * **/
export const usePressKeyboard = <T>({ appMode, multipleMode }: { appMode: T; multipleMode: T[] }) => {
  const [isSpaceBarPressed, setIsSpaceBarPressed] = useState(false);
  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const [isAltPressed, setIsAltPressed] = useState(false);

  useEffect(() => {
    /**
     * Press SPACE bar to move the map
     * Press Alt key to select multi object
     * Press Shift key to select single object
     * **/
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.repeat) {
        return;
      }
      if (event.code === "Space") {
        setIsSpaceBarPressed(true);
        setIsAltPressed(false);
        setIsShiftPressed(false);
      } else if (event.key === "Alt") {
        setIsAltPressed(true);
        setIsShiftPressed(false);
      } else if (event.key === "Shift") {
        setIsShiftPressed(true);
        setIsAltPressed(false);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.code === "Space") {
        setIsSpaceBarPressed(false);
      } else if (event.key === "Alt") {
        setIsAltPressed(false);
      } else if (event.key === "Shift") {
        setIsShiftPressed(false);
      }
    };

    if (!multipleMode.includes(appMode)) {
      setIsSpaceBarPressed(false);
      setIsAltPressed(false);
      setIsShiftPressed(false);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      return;
    }

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [appMode, multipleMode]);
  return {
    isSpaceBarPressed,
    isShiftPressed,
    isAltPressed,
  };
};
